import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const staffAPI = createApi({
    reducerPath: "staffAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllStaffs: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/staff?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["staff"],
        }),
        getSpecificStaffDetails: builder.mutation({
            query: ({ id }) => {
                let apiUrl = `admin/staff/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        createStaff: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/staff",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["staff"],
        }),
        updateStaff: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/staff`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["staff"],
        }),
        deleteStaff: builder.mutation({
            query: ({ id }) => {
                return {
                    url: `admin/staff/${id}`,
                    method: "DELETE"
                };
            },
            invalidatesTags: ["staff"],
        }),
        updateStaffNotifications: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/staff/subscribe-notification`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["staff"],
        }),
    })
});

export const { 
    useGetAllStaffsMutation,
    useGetSpecificStaffDetailsMutation,
    useCreateStaffMutation,
    useUpdateStaffMutation,
    useDeleteStaffMutation,
    useUpdateStaffNotificationsMutation
} = staffAPI;

export default staffAPI;